import React,{useState,useEffect} from 'react';
import './App.css';
import {supabase} from './supabase/supabase';
import Footer from './components/Footer';

// 🎯 Utility functions
const hashPassword=(p)=> btoa(p);

// 🎯 Custom hook for Supabase operations
const useSupabaseData=(table,options={})=> {
const [data,setData]=useState([]);
const [loading,setLoading]=useState(true);
const [error,setError]=useState(null);

const fetchData=async ()=> {
try {
setLoading(true);
setError(null);
let query=supabase.from(table).select('*');

if (options.filter) {
Object.entries(options.filter).forEach(([key,value])=> {
query=query.eq(key,value);
});
}

if (options.orderBy) {
query=query.order(options.orderBy,{ascending: options.ascending !==false});
}

const {data: result,error}=await query;

if (error) throw error;
setData(result || []);
} catch (err) {
console.error(`Error fetching from ${table}:`,err);
setError(err.message);
} finally {
setLoading(false);
}
};

const insertData=async (newData)=> {
try {
const {data: result,error}=await supabase
.from(table)
.insert(newData)
.select();

if (error) throw error;
await fetchData();
return result[0];
} catch (err) {
console.error(`Error inserting into ${table}:`,err);
setError(err.message);
throw err;
}
};

const updateData=async (id,updateData)=> {
try {
const {data: result,error}=await supabase
.from(table)
.update(updateData)
.eq('id',id)
.select();

if (error) throw error;
await fetchData();
return result[0];
} catch (err) {
console.error(`Error updating ${table}:`,err);
setError(err.message);
throw err;
}
};

const deleteData=async (id)=> {
try {
const {error}=await supabase
.from(table)
.delete()
.eq('id',id);

if (error) throw error;
await fetchData();
} catch (err) {
console.error(`Error deleting from ${table}:`,err);
setError(err.message);
throw err;
}
};

useEffect(()=> {
fetchData();
},[table,JSON.stringify(options)]);

return {data,loading,error,refetch: fetchData,insert: insertData,update: updateData,delete: deleteData};
};

// 🎯 Main App Component
const App=()=> {
const [activeUser,setActiveUser]=useState(()=> {
const saved=localStorage.getItem('pay4referralActiveUser');
return saved ? JSON.parse(saved) : null;
});

const [theme,setTheme]=useState(()=> {
const saved=localStorage.getItem('pay4referralTheme');
return saved || 'light';
});

useEffect(()=> {
localStorage.setItem('pay4referralActiveUser',JSON.stringify(activeUser));
},[activeUser]);

useEffect(()=> {
localStorage.setItem('pay4referralTheme',theme);
},[theme]);

const toggleTheme=()=> setTheme(theme==='light' ? 'dark' : 'light');
const handleLogout=()=> setActiveUser(null);

return (
 <div className={`min-h-screen flex flex-col transition-colors duration-300 ${theme==='dark' ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
 <Header activeUser={activeUser} theme={theme} toggleTheme={toggleTheme} onLogout={handleLogout} />
 <main className="container mx-auto px-4 py-8 flex-grow">
 {!activeUser ? (
 <LoginForm onLogin={setActiveUser} theme={theme} />
 ) : activeUser.ruolo==='admin' ? (
 <AdminDashboard theme={theme} />
 ) : activeUser.ruolo==='azienda' ? (
 <AziendaDashboard aziendaId={activeUser.id} theme={theme} />
 ) : (
 <SegnalatoreDashboard segnalatoreId={activeUser.id} theme={theme} />
 )}
 </main>
 <Footer theme={theme} />
 </div>
 );
};

// 🎯 Header Component
const Header=({activeUser,theme,toggleTheme,onLogout})=> (
 <header className={`border-b ${theme==='dark' ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
 <div className="container mx-auto px-4 py-4 flex justify-between items-center">
 <div className="flex items-center space-x-3">
 <span className="text-2xl">💰</span>
 <h1 className="text-xl font-bold text-green-600">Pay4Referral</h1>
 {activeUser && (
 <span className={`text-sm px-2 py-1 rounded ${theme==='dark' ? 'bg-gray-700' : 'bg-gray-200'}`}>
 {activeUser.ruolo}
 </span>
 )}
 </div>
 <div className="flex items-center space-x-4">
 <button onClick={toggleTheme} className={`p-2 rounded-full ${theme==='dark' ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'}`}>
 {theme==='dark' ? '🌞' : '🌙'}
 </button>
 {activeUser && (
 <button onClick={onLogout} className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-red-600 hover:bg-red-700' : 'bg-red-500 hover:bg-red-600 text-white'}`}>
 Logout
 </button>
 )}
 </div>
 </div>
 </header>
);

// 🎯 Login Form Component
const LoginForm=({onLogin,theme})=> {
const [loginType,setLoginType]=useState('admin');
const [username,setUsername]=useState('');
const [password,setPassword]=useState('');
const [error,setError]=useState('');
const [loading,setLoading]=useState(false);

const handleSubmit=async (e)=> {
e.preventDefault();
setError('');
setLoading(true);

try {
if (loginType==='admin') {
console.log('Admin login attempt');
if (password==='<k1_pI5g$-?#^pE') {
console.log('Admin login successful');
onLogin({id: 'admin',ruolo: 'admin'});
return;
} else {
console.log('Admin password incorrect');
setError('Password admin errata');
return;
}
}

const tableName=loginType==='azienda' ? 'aziende' : 'segnalatori';
const {data,error}=await supabase
.from(tableName)
.select('*')
.eq('username',username)
.single();

if (error || !data) {
setError(`Credenziali ${loginType} errate`);
return;
}

if (atob(data.password_hash)===password) {
onLogin({id: data.id,ruolo: loginType,...(loginType==='segnalatore' && {azienda_id: data.azienda_id})});
} else {
setError(`Credenziali ${loginType} errate`);
}
} catch (err) {
console.error('Login error:',err);
setError('Errore durante il login. Riprova.');
} finally {
setLoading(false);
}
};

return (
 <div className={`max-w-md mx-auto p-6 rounded-lg shadow-lg ${theme==='dark' ? 'bg-gray-800' : 'bg-white'}`}>
 <h2 className="text-2xl font-bold mb-6 text-center">Accesso Pay4Referral</h2>
 <div className="flex mb-6 border-b">
 {['admin','azienda','segnalatore'].map(type=> (
 <button key={type} onClick={()=> setLoginType(type)} className={`flex-1 py-2 text-sm font-medium ${loginType===type ? theme==='dark' ? 'border-b-2 border-green-500 text-green-500' : 'border-b-2 border-green-600 text-green-600' : theme==='dark' ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`}>
 {type.charAt(0).toUpperCase() + type.slice(1)}
 </button>
 ))}
 </div>
 <form onSubmit={handleSubmit} className="space-y-4">
 {loginType !=='admin' && (
 <div>
 <label className="block text-sm font-medium mb-2">Username</label>
 <input type="text" value={username} onChange={(e)=> setUsername(e.target.value)} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 )}
 <div>
 <label className="block text-sm font-medium mb-2">
 {loginType==='admin' ? 'Password Admin' : 'Password'}
 </label>
 <input type="password" value={password} onChange={(e)=> setPassword(e.target.value)} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 {error && (
 <div className={`p-3 rounded ${theme==='dark' ? 'bg-red-900 text-red-200' : 'bg-red-100 text-red-700'}`}>
 {error}
 </div>
 )}
 <button type="submit" disabled={loading} className={`w-full py-3 px-4 rounded font-medium ${theme==='dark' ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600 text-white'} ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}>
 {loading ? 'Accesso...' : 'Accedi'}
 </button>
 </form>
 {loginType==='admin' && (
 <div className={`mt-4 p-3 rounded text-sm ${theme==='dark' ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-600'}`}>
 <p>Per accedere come admin,usa la password configurata nell'applicazione.</p>
 <p className="text-xs mt-2 text-yellow-600">Per motivi di sicurezza, la password non viene mostrata qui.</p>
 </div>
 )}
 </div>
 );
};

// 🎯 Admin Dashboard Component
const AdminDashboard=({theme})=> {
const [activeTab,setActiveTab]=useState('aziende');
const [showCompanyForm,setShowCompanyForm]=useState(false);
const [editingCompany,setEditingCompany]=useState(null);

const {data: companies,loading: companiesLoading,insert: insertCompany,update: updateCompany,delete: deleteCompany}=useSupabaseData('aziende');
const {data: reporters,refetch: refetchReporters}=useSupabaseData('segnalatori');
const {data: reports,refetch: refetchReports}=useSupabaseData('segnalazioni');
const {data: news,refetch: refetchNews}=useSupabaseData('notizie');

const tabs=[
 {id: 'aziende',label: 'Aziende',count: companies.length},
 {id: 'segnalatori',label: 'Segnalatori',count: reporters.length},
 {id: 'segnalazioni',label: 'Segnalazioni',count: reports.length},
 {id: 'notizie',label: 'Notizie',count: news.length}
];

const handleAddCompany=async (companyData)=> {
try {
await insertCompany({username: companyData.username,password_hash: hashPassword(companyData.password)});
setShowCompanyForm(false);
} catch (err) {
alert('Errore durante la creazione dell\'azienda: ' + err.message);
}
};

const handleEditCompany=async (companyId,newPassword)=> {
try {
await updateCompany(companyId,{password_hash: hashPassword(newPassword)});
setEditingCompany(null);
} catch (err) {
alert('Errore durante la modifica dell\'azienda: ' + err.message);
}
};

const handleDeleteCompany=async (companyId)=> {
try {
await deleteCompany(companyId);
await refetchReporters();
await refetchReports();
await refetchNews();
} catch (err) {
alert('Errore durante l\'eliminazione dell\'azienda: ' + err.message);
}
};

if (companiesLoading) {
return <div className="text-center py-8">Caricamento...</div>;
}

return (
 <div>
 <h2 className="text-3xl font-bold mb-8">Dashboard Admin</h2>
 <div className="flex border-b mb-6">
 {tabs.map(tab=> (
 <button key={tab.id} onClick={()=> setActiveTab(tab.id)} className={`px-6 py-3 font-medium ${activeTab===tab.id ? theme==='dark' ? 'border-b-2 border-green-500 text-green-500' : 'border-b-2 border-green-600 text-green-600' : theme==='dark' ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`}>
 {tab.label} ({tab.count})
 </button>
 ))}
 </div>

 {activeTab==='aziende' && (
 <div>
 <div className="flex justify-between items-center mb-6">
 <h3 className="text-2xl font-bold">Gestione Aziende</h3>
 <button onClick={()=> setShowCompanyForm(true)} className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600 text-white'}`}>
 + Nuova Azienda
 </button>
 </div>

 {showCompanyForm && (
 <CompanyForm theme={theme} onSubmit={handleAddCompany} onCancel={()=> setShowCompanyForm(false)} />
 )}

 {editingCompany && (
 <PasswordChangeForm theme={theme} userType="azienda" onSubmit={(newPassword)=> handleEditCompany(editingCompany,newPassword)} onCancel={()=> setEditingCompany(null)} />
 )}

 <div className="grid gap-4">
 {companies.map(company=> (
 <div key={company.id} className={`p-4 rounded-lg ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <div className="flex justify-between items-center">
 <div>
 <h4 className="font-bold text-lg">{company.username}</h4>
 <p className={`text-sm ${theme==='dark' ? 'text-gray-400' : 'text-gray-600'}`}>Azienda</p>
 </div>
 <div className="flex space-x-2">
 <button onClick={()=> setEditingCompany(company.id)} className={`px-3 py-1 rounded ${theme==='dark' ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600 text-white'}`}>
 Cambia Password
 </button>
 <button onClick={()=> handleDeleteCompany(company.id)} className={`px-3 py-1 rounded ${theme==='dark' ? 'bg-red-600 hover:bg-red-700' : 'bg-red-500 hover:bg-red-600 text-white'}`}>
 Elimina
 </button>
 </div>
 </div>
 </div>
 ))}
 </div>
 </div>
 )}

 {activeTab==='segnalatori' && (
 <div>
 <h3 className="text-2xl font-bold mb-6">Tutti i Segnalatori</h3>
 <div className="grid gap-4">
 {reporters.map(reporter=> {
const company=companies.find(a=> a.id===reporter.azienda_id);
return (
 <div key={reporter.id} className={`p-4 rounded-lg ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <div className="flex justify-between items-center">
 <div>
 <h4 className="font-bold text-lg">{reporter.username}</h4>
 <p className={`text-sm ${theme==='dark' ? 'text-gray-400' : 'text-gray-600'}`}>
 Azienda: {company?.username || 'N/A'}
 </p>
 </div>
 </div>
 </div>
 );
})}
 </div>
 </div>
 )}

 {activeTab==='segnalazioni' && (
 <ReportsList reports={reports} reporters={reporters} companies={companies} theme={theme} canEdit={true} refetchReports={refetchReports} />
 )}

 {activeTab==='notizie' && (
 <NewsList news={news} companies={companies} theme={theme} canEdit={true} />
 )}
 </div>
 );
};

// 🎯 Company Dashboard Component
const AziendaDashboard=({aziendaId,theme})=> {
const [activeTab,setActiveTab]=useState('segnalatori');
const [showReporterForm,setShowReporterForm]=useState(false);
const [showNewsForm,setShowNewsForm]=useState(false);
const [editingNews,setEditingNews]=useState(null);
const [editingReporter,setEditingReporter]=useState(null);

const {data: reporters,insert: insertReporter,update: updateReporter,delete: deleteReporter}=useSupabaseData('segnalatori',{filter: {azienda_id: aziendaId}});
const {data: reports,refetch: refetchReports}=useSupabaseData('segnalazioni',{filter: {azienda_id: aziendaId}});
const {data: news,insert: insertNews,update: updateNews,delete: deleteNews}=useSupabaseData('notizie',{filter: {azienda_id: aziendaId}});

const tabs=[
 {id: 'segnalatori',label: 'Segnalatori',count: reporters.length},
 {id: 'segnalazioni',label: 'Segnalazioni',count: reports.length},
 {id: 'notizie',label: 'Notizie',count: news.length}
];

const handleAddReporter=async (reporterData)=> {
try {
await insertReporter({username: reporterData.username,password_hash: hashPassword(reporterData.password),azienda_id: aziendaId});
setShowReporterForm(false);
} catch (err) {
alert('Errore durante la creazione del segnalatore: ' + err.message);
}
};

const handleEditReporter=async (reporterId,newPassword)=> {
try {
await updateReporter(reporterId,{password_hash: hashPassword(newPassword)});
setEditingReporter(null);
} catch (err) {
alert('Errore durante la modifica del segnalatore: ' + err.message);
}
};

const handleDeleteReporter=async (reporterId)=> {
try {
await deleteReporter(reporterId);
await refetchReports();
} catch (err) {
alert('Errore durante l\'eliminazione del segnalatore: ' + err.message);
}
};

const handleAddNews=async (newsData)=> {
try {
await insertNews({azienda_id: aziendaId,titolo: newsData.titolo,testo: newsData.testo,data_pubblicazione: new Date().toISOString()});
setShowNewsForm(false);
} catch (err) {
alert('Errore durante la creazione della notizia: ' + err.message);
}
};

const handleEditNews=async (newsId,newsData)=> {
try {
await updateNews(newsId,newsData);
setEditingNews(null);
} catch (err) {
alert('Errore durante la modifica della notizia: ' + err.message);
}
};

const handleDeleteNews=async (newsId)=> {
try {
await deleteNews(newsId);
} catch (err) {
alert('Errore durante l\'eliminazione della notizia: ' + err.message);
}
};

return (
 <div>
 <h2 className="text-3xl font-bold mb-8">Dashboard Azienda</h2>
 <div className="flex border-b mb-6">
 {tabs.map(tab=> (
 <button key={tab.id} onClick={()=> setActiveTab(tab.id)} className={`px-6 py-3 font-medium ${activeTab===tab.id ? theme==='dark' ? 'border-b-2 border-green-500 text-green-500' : 'border-b-2 border-green-600 text-green-600' : theme==='dark' ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`}>
 {tab.label} ({tab.count})
 </button>
 ))}
 </div>

 {activeTab==='segnalatori' && (
 <div>
 <div className="flex justify-between items-center mb-6">
 <h3 className="text-2xl font-bold">I miei Segnalatori</h3>
 <button onClick={()=> setShowReporterForm(true)} className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600 text-white'}`}>
 + Nuovo Segnalatore
 </button>
 </div>

 {showReporterForm && (
 <CompanyForm theme={theme} onSubmit={handleAddReporter} onCancel={()=> setShowReporterForm(false)} />
 )}

 {editingReporter && (
 <PasswordChangeForm theme={theme} userType="segnalatore" onSubmit={(newPassword)=> handleEditReporter(editingReporter,newPassword)} onCancel={()=> setEditingReporter(null)} />
 )}

 <div className="grid gap-4">
 {reporters.map(reporter=> (
 <div key={reporter.id} className={`p-4 rounded-lg ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <div className="flex justify-between items-center">
 <div>
 <h4 className="font-bold text-lg">{reporter.username}</h4>
 <p className={`text-sm ${theme==='dark' ? 'text-gray-400' : 'text-gray-600'}`}>Segnalatore</p>
 </div>
 <div className="flex space-x-2">
 <button onClick={()=> setEditingReporter(reporter.id)} className={`px-3 py-1 rounded ${theme==='dark' ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600 text-white'}`}>
 Cambia Password
 </button>
 <button onClick={()=> handleDeleteReporter(reporter.id)} className={`px-3 py-1 rounded ${theme==='dark' ? 'bg-red-600 hover:bg-red-700' : 'bg-red-500 hover:bg-red-600 text-white'}`}>
 Elimina
 </button>
 </div>
 </div>
 </div>
 ))}
 </div>
 </div>
 )}

 {activeTab==='segnalazioni' && (
 <ReportsList reports={reports} reporters={reporters} theme={theme} canEdit={true} refetchReports={refetchReports} aziendaId={aziendaId} />
 )}

 {activeTab==='notizie' && (
 <div>
 <div className="flex justify-between items-center mb-6">
 <h3 className="text-2xl font-bold">Le mie Notizie</h3>
 <button onClick={()=> setShowNewsForm(true)} className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600 text-white'}`}>
 + Nuova Notizia
 </button>
 </div>

 {(showNewsForm || editingNews) && (
 <NewsForm theme={theme} news={editingNews} onSubmit={editingNews ? (data)=> handleEditNews(editingNews.id,data) : handleAddNews} onCancel={()=> {setShowNewsForm(false);setEditingNews(null);}} />
 )}

 <div className="grid gap-4">
 {news.map(item=> (
 <div key={item.id} className={`p-4 rounded-lg ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <div className="flex justify-between items-center mb-3">
 <h4 className="font-bold text-lg">{item.titolo}</h4>
 <div className="flex space-x-2">
 <button onClick={()=> setEditingNews(item)} className={`px-3 py-1 rounded ${theme==='dark' ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600 text-white'}`}>
 Modifica
 </button>
 <button onClick={()=> handleDeleteNews(item.id)} className={`px-3 py-1 rounded ${theme==='dark' ? 'bg-red-600 hover:bg-red-700' : 'bg-red-500 hover:bg-red-600 text-white'}`}>
 Elimina
 </button>
 </div>
 </div>
 <p className={`mb-2 ${theme==='dark' ? 'text-gray-300' : 'text-gray-700'}`}>{item.testo}</p>
 <p className={`text-sm ${theme==='dark' ? 'text-gray-400' : 'text-gray-500'}`}>
 {new Date(item.data_pubblicazione).toLocaleDateString()}
 </p>
 </div>
 ))}
 </div>
 </div>
 )}
 </div>
 );
};

// 🎯 Reporter Dashboard Component
const SegnalatoreDashboard=({segnalatoreId,theme})=> {
const [activeTab,setActiveTab]=useState('segnalazioni');
const [showReportForm,setShowReportForm]=useState(false);
const [selectedReport,setSelectedReport]=useState(null);

const {data: companies}=useSupabaseData('aziende');
const {data: reporters}=useSupabaseData('segnalatori');
const {data: reports,insert: insertReport}=useSupabaseData('segnalazioni',{filter: {user_id: segnalatoreId}});
const {data: news}=useSupabaseData('notizie');

const myReporter=reporters.find(r=> r.id===segnalatoreId);
const myNews=news.filter(n=> n.azienda_id===myReporter?.azienda_id);

const tabs=[
 {id: 'segnalazioni',label: 'Le mie Segnalazioni',count: reports.length},
 {id: 'notizie',label: 'Notizie',count: myNews.length}
];

const handleAddReport=async (reportData)=> {
try {
await insertReport({user_id: segnalatoreId,azienda_id: myReporter.azienda_id,nome_azienda: reportData.nome_azienda,nome_titolare: reportData.nome_titolare,contatto_titolare: reportData.contatto_titolare,altre_informazioni: reportData.altre_informazioni,stato_segnalazione: 'da lavorare'});
setShowReportForm(false);
} catch (err) {
alert('Errore durante la creazione della segnalazione: ' + err.message);
}
};

return (
 <div>
 <h2 className="text-3xl font-bold mb-8">Dashboard Segnalatore</h2>
 <div className="flex border-b mb-6">
 {tabs.map(tab=> (
 <button key={tab.id} onClick={()=> setActiveTab(tab.id)} className={`px-6 py-3 font-medium ${activeTab===tab.id ? theme==='dark' ? 'border-b-2 border-green-500 text-green-500' : 'border-b-2 border-green-600 text-green-600' : theme==='dark' ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`}>
 {tab.label} ({tab.count})
 </button>
 ))}
 </div>

 {activeTab==='segnalazioni' && (
 <div>
 <div className="flex justify-between items-center mb-6">
 <h3 className="text-2xl font-bold">Le mie Segnalazioni</h3>
 <button onClick={()=> setShowReportForm(true)} className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600 text-white'}`}>
 + Nuova Segnalazione
 </button>
 </div>

 {showReportForm && (
 <ReportForm theme={theme} onSubmit={handleAddReport} onCancel={()=> setShowReportForm(false)} />
 )}

 <div className="grid gap-4">
 {reports.map(report=> (
 <div key={report.id} className={`p-4 rounded-lg ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <div className="flex justify-between items-center mb-3">
 <div>
 <h4 className="font-bold text-lg">{report.nome_azienda}</h4>
 <p className={`text-sm ${theme==='dark' ? 'text-gray-400' : 'text-gray-600'}`}>
 Titolare: {report.nome_titolare}
 </p>
 </div>
 <div className="flex space-x-2">
 <button onClick={()=> setSelectedReport(report)} className={`px-3 py-1 rounded ${theme==='dark' ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600 text-white'}`}>
 Dettagli
 </button>
 </div>
 </div>
 <div className={`inline-block px-2 py-1 rounded text-sm ${report.stato_segnalazione==='chiusura' ? 'bg-green-500' : report.stato_segnalazione==='secondo appuntamento fissato' ? 'bg-purple-500' : report.stato_segnalazione==='appuntamento fissato' ? 'bg-blue-500' : report.stato_segnalazione==='da lavorare' ? 'bg-yellow-500' : report.stato_segnalazione==='non interessato' ? 'bg-red-500' : 'bg-gray-500'} text-white`}>
 {report.stato_segnalazione}
 </div>
 </div>
 ))}
 </div>
 </div>
 )}

 {activeTab==='notizie' && (
 <NewsList news={myNews} theme={theme} canEdit={false} />
 )}

 {selectedReport && (
 <ReportModal report={selectedReport} theme={theme} onClose={()=> setSelectedReport(null)} />
 )}
 </div>
 );
};

// 🎯 Company/Reporter Form Component
const CompanyForm=({theme,onSubmit,onCancel})=> {
const [username,setUsername]=useState('');
const [password,setPassword]=useState('');

const handleSubmit=(e)=> {
e.preventDefault();
onSubmit({username,password});
setUsername('');
setPassword('');
};

return (
 <div className={`p-6 rounded-lg mb-6 ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <h3 className="text-xl font-bold mb-4">Nuovo Utente</h3>
 <form onSubmit={handleSubmit} className="space-y-4">
 <div>
 <label className="block text-sm font-medium mb-2">Username</label>
 <input type="text" value={username} onChange={(e)=> setUsername(e.target.value)} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div>
 <label className="block text-sm font-medium mb-2">Password</label>
 <input type="password" value={password} onChange={(e)=> setPassword(e.target.value)} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div className="flex space-x-3">
 <button type="submit" className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600 text-white'}`}>
 Crea
 </button>
 <button type="button" onClick={onCancel} className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-gray-600 hover:bg-gray-700' : 'bg-gray-300 hover:bg-gray-400'}`}>
 Annulla
 </button>
 </div>
 </form>
 </div>
 );
};

// 🎯 Password Change Form Component
const PasswordChangeForm=({theme,userType,onSubmit,onCancel})=> {
const [newPassword,setNewPassword]=useState('');

const handleSubmit=(e)=> {
e.preventDefault();
onSubmit(newPassword);
setNewPassword('');
};

return (
 <div className={`p-6 rounded-lg mb-6 ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <h3 className="text-xl font-bold mb-4">
 Cambia Password {userType==='azienda' ? 'Azienda' : 'Segnalatore'}
 </h3>
 <form onSubmit={handleSubmit} className="space-y-4">
 <div>
 <label className="block text-sm font-medium mb-2">Nuova Password</label>
 <input type="password" value={newPassword} onChange={(e)=> setNewPassword(e.target.value)} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div className="flex space-x-3">
 <button type="submit" className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600 text-white'}`}>
 Cambia Password
 </button>
 <button type="button" onClick={onCancel} className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-gray-600 hover:bg-gray-700' : 'bg-gray-300 hover:bg-gray-400'}`}>
 Annulla
 </button>
 </div>
 </form>
 </div>
 );
};

// 🎯 Report Form Component
const ReportForm=({theme,onSubmit,onCancel})=> {
const [formData,setFormData]=useState({nome_azienda: '',nome_titolare: '',contatto_titolare: '',altre_informazioni: ''});

const handleSubmit=(e)=> {
e.preventDefault();
onSubmit(formData);
};

return (
 <div className={`p-6 rounded-lg mb-6 ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <h3 className="text-xl font-bold mb-4">Nuova Segnalazione</h3>
 <form onSubmit={handleSubmit} className="space-y-4">
 <div>
 <label className="block text-sm font-medium mb-2">Nome Azienda *</label>
 <input type="text" value={formData.nome_azienda} onChange={(e)=> setFormData({...formData,nome_azienda: e.target.value})} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div>
 <label className="block text-sm font-medium mb-2">Nome Titolare *</label>
 <input type="text" value={formData.nome_titolare} onChange={(e)=> setFormData({...formData,nome_titolare: e.target.value})} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div>
 <label className="block text-sm font-medium mb-2">Contatto Titolare *</label>
 <input type="text" value={formData.contatto_titolare} onChange={(e)=> setFormData({...formData,contatto_titolare: e.target.value})} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div>
 <label className="block text-sm font-medium mb-2">Altre Informazioni</label>
 <textarea value={formData.altre_informazioni} onChange={(e)=> setFormData({...formData,altre_informazioni: e.target.value})} rows={3} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} />
 </div>
 <div className="flex space-x-3">
 <button type="submit" className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600 text-white'}`}>
 Crea Segnalazione
 </button>
 <button type="button" onClick={onCancel} className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-gray-600 hover:bg-gray-700' : 'bg-gray-300 hover:bg-gray-400'}`}>
 Annulla
 </button>
 </div>
 </form>
 </div>
 );
};

// 🎯 Report Status Edit Form Component
const ReportStatusForm=({theme,report,onSubmit,onCancel})=> {
const [formData,setFormData]=useState({nome_azienda: report?.nome_azienda || '',nome_titolare: report?.nome_titolare || '',contatto_titolare: report?.contatto_titolare || '',altre_informazioni: report?.altre_informazioni || '',stato_segnalazione: report?.stato_segnalazione || 'da lavorare'});

const handleSubmit=(e)=> {
e.preventDefault();
onSubmit(formData);
};

return (
 <div className={`p-6 rounded-lg mb-6 ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <h3 className="text-xl font-bold mb-4">Modifica Segnalazione</h3>
 <form onSubmit={handleSubmit} className="space-y-4">
 <div>
 <label className="block text-sm font-medium mb-2">Nome Azienda *</label>
 <input type="text" value={formData.nome_azienda} onChange={(e)=> setFormData({...formData,nome_azienda: e.target.value})} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div>
 <label className="block text-sm font-medium mb-2">Nome Titolare *</label>
 <input type="text" value={formData.nome_titolare} onChange={(e)=> setFormData({...formData,nome_titolare: e.target.value})} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div>
 <label className="block text-sm font-medium mb-2">Contatto Titolare *</label>
 <input type="text" value={formData.contatto_titolare} onChange={(e)=> setFormData({...formData,contatto_titolare: e.target.value})} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div>
 <label className="block text-sm font-medium mb-2">Stato Segnalazione *</label>
 <select value={formData.stato_segnalazione} onChange={(e)=> setFormData({...formData,stato_segnalazione: e.target.value})} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`}>
 <option value="da lavorare">Da lavorare</option>
 <option value="appuntamento fissato">Appuntamento fissato</option>
 <option value="secondo appuntamento fissato">Secondo appuntamento fissato</option>
 <option value="chiusura">Chiusura</option>
 <option value="non interessato">Non interessato</option>
 </select>
 </div>
 <div>
 <label className="block text-sm font-medium mb-2">Altre Informazioni</label>
 <textarea value={formData.altre_informazioni} onChange={(e)=> setFormData({...formData,altre_informazioni: e.target.value})} rows={3} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} />
 </div>
 <div className="flex space-x-3">
 <button type="submit" className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600 text-white'}`}>
 Aggiorna Segnalazione
 </button>
 <button type="button" onClick={onCancel} className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-gray-600 hover:bg-gray-700' : 'bg-gray-300 hover:bg-gray-400'}`}>
 Annulla
 </button>
 </div>
 </form>
 </div>
 );
};

// 🎯 News Form Component
const NewsForm=({theme,news,onSubmit,onCancel})=> {
const [formData,setFormData]=useState({titolo: news?.titolo || '',testo: news?.testo || ''});

const handleSubmit=(e)=> {
e.preventDefault();
onSubmit(formData);
};

return (
 <div className={`p-6 rounded-lg mb-6 ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <h3 className="text-xl font-bold mb-4">
 {news ? 'Modifica Notizia' : 'Nuova Notizia'}
 </h3>
 <form onSubmit={handleSubmit} className="space-y-4">
 <div>
 <label className="block text-sm font-medium mb-2">Titolo *</label>
 <input type="text" value={formData.titolo} onChange={(e)=> setFormData({...formData,titolo: e.target.value})} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div>
 <label className="block text-sm font-medium mb-2">Testo *</label>
 <textarea value={formData.testo} onChange={(e)=> setFormData({...formData,testo: e.target.value})} rows={5} className={`w-full p-3 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`} required />
 </div>
 <div className="flex space-x-3">
 <button type="submit" className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-green-600 hover:bg-green-700' : 'bg-green-500 hover:bg-green-600 text-white'}`}>
 {news ? 'Aggiorna' : 'Pubblica'} Notizia
 </button>
 <button type="button" onClick={onCancel} className={`px-4 py-2 rounded ${theme==='dark' ? 'bg-gray-600 hover:bg-gray-700' : 'bg-gray-300 hover:bg-gray-400'}`}>
 Annulla
 </button>
 </div>
 </form>
 </div>
 );
};

// 🎯 Reports List Component
const ReportsList=({reports,reporters,companies,theme,canEdit,refetchReports,aziendaId})=> {
const [selectedReport,setSelectedReport]=useState(null);
const [statusFilter,setStatusFilter]=useState('Tutti');
const [editingReport,setEditingReport]=useState(null);

const {update: updateReport,delete: deleteReport}=useSupabaseData('segnalazioni');

const filteredReports=statusFilter==='Tutti' ? reports : reports.filter(r=> r.stato_segnalazione===statusFilter);

const getReporterName=(userId)=> {
const reporter=reporters?.find(r=> r.id===userId);
return reporter?.username || 'N/A';
};

const getCompanyName=(companyId)=> {
const company=companies?.find(a=> a.id===companyId);
return company?.username || 'N/A';
};

const handleEditReport=async (reportId,reportData)=> {
try {
await updateReport(reportId,reportData);
setEditingReport(null);
if (refetchReports) refetchReports();
} catch (err) {
alert('Errore durante la modifica della segnalazione: ' + err.message);
}
};

const handleDeleteReport=async (reportId)=> {
try {
await deleteReport(reportId);
if (refetchReports) refetchReports();
} catch (err) {
alert('Errore durante l\'eliminazione della segnalazione: ' + err.message);
}
};

const canEditReport=(report)=> {
if (!canEdit) return false;
return !aziendaId || report.azienda_id===aziendaId;
};

return (
 <div>
 <div className="flex justify-between items-center mb-6">
 <h3 className="text-2xl font-bold">Segnalazioni</h3>
 <select value={statusFilter} onChange={(e)=> setStatusFilter(e.target.value)} className={`p-2 border rounded ${theme==='dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'}`}>
 <option value="Tutti">Tutti gli stati</option>
 <option value="da lavorare">Da lavorare</option>
 <option value="appuntamento fissato">Appuntamento fissato</option>
 <option value="secondo appuntamento fissato">Secondo appuntamento fissato</option>
 <option value="chiusura">Chiusura</option>
 <option value="non interessato">Non interessato</option>
 </select>
 </div>

 {editingReport && (
 <ReportStatusForm theme={theme} report={editingReport} onSubmit={(data)=> handleEditReport(editingReport.id,data)} onCancel={()=> setEditingReport(null)} />
 )}

 <div className="grid gap-4">
 {filteredReports.map(report=> (
 <div key={report.id} className={`p-4 rounded-lg ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <div className="flex justify-between items-center mb-3">
 <div>
 <h4 className="font-bold text-lg">{report.nome_azienda}</h4>
 <p className={`text-sm ${theme==='dark' ? 'text-gray-400' : 'text-gray-600'}`}>
 Titolare: {report.nome_titolare}
 </p>
 {companies && (
 <p className={`text-xs ${theme==='dark' ? 'text-gray-500' : 'text-gray-500'}`}>
 Segnalatore: {getReporterName(report.user_id)} | Azienda: {getCompanyName(report.azienda_id)}
 </p>
 )}
 </div>
 <div className="flex space-x-2">
 <button onClick={()=> setSelectedReport(report)} className={`px-3 py-1 rounded ${theme==='dark' ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600 text-white'}`}>
 Dettagli
 </button>
 {canEditReport(report) && (
 <>
 <button onClick={()=> setEditingReport(report)} className={`px-3 py-1 rounded ${theme==='dark' ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-yellow-500 hover:bg-yellow-600 text-white'}`}>
 Modifica
 </button>
 <button onClick={()=> handleDeleteReport(report.id)} className={`px-3 py-1 rounded ${theme==='dark' ? 'bg-red-600 hover:bg-red-700' : 'bg-red-500 hover:bg-red-600 text-white'}`}>
 Elimina
 </button>
 </>
 )}
 </div>
 </div>
 <div className={`inline-block px-2 py-1 rounded text-sm ${report.stato_segnalazione==='chiusura' ? 'bg-green-500' : report.stato_segnalazione==='secondo appuntamento fissato' ? 'bg-purple-500' : report.stato_segnalazione==='appuntamento fissato' ? 'bg-blue-500' : report.stato_segnalazione==='da lavorare' ? 'bg-yellow-500' : report.stato_segnalazione==='non interessato' ? 'bg-red-500' : 'bg-gray-500'} text-white`}>
 {report.stato_segnalazione}
 </div>
 </div>
 ))}
 </div>

 {selectedReport && (
 <ReportModal report={selectedReport} theme={theme} onClose={()=> setSelectedReport(null)} />
 )}
 </div>
 );
};

// 🎯 News List Component
const NewsList=({news,companies,theme})=> (
 <div>
 <h3 className="text-2xl font-bold mb-6">Notizie</h3>
 <div className="grid gap-4">
 {news.map(item=> {
const companyName=companies?.find(a=> a.id===item.azienda_id)?.username || 'N/A';
return (
 <div key={item.id} className={`p-4 rounded-lg ${theme==='dark' ? 'bg-gray-800' : 'bg-white shadow'}`}>
 <div className="flex justify-between items-center mb-3">
 <div>
 <h4 className="font-bold text-lg">{item.titolo}</h4>
 {companies && (
 <p className={`text-sm ${theme==='dark' ? 'text-gray-400' : 'text-gray-600'}`}>
 Pubblicato da: {companyName}
 </p>
 )}
 </div>
 <p className={`text-sm ${theme==='dark' ? 'text-gray-400' : 'text-gray-500'}`}>
 {new Date(item.data_pubblicazione).toLocaleDateString()}
 </p>
 </div>
 <p className={`mb-2 ${theme==='dark' ? 'text-gray-300' : 'text-gray-700'}`}>{item.testo}</p>
 </div>
 );
})}
 </div>
 </div>
);

// 🎯 Report Modal Component
const ReportModal=({report,theme,onClose})=> (
 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
 <div className={`max-w-2xl w-full max-h-[90vh] overflow-y-auto rounded-lg ${theme==='dark' ? 'bg-gray-800' : 'bg-white'}`}>
 <div className="p-6">
 <div className="flex justify-between items-center mb-6">
 <h3 className="text-2xl font-bold">Dettagli Segnalazione</h3>
 <button onClick={onClose} className={`p-2 rounded-full ${theme==='dark' ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'}`}>
 ×
 </button>
 </div>

 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
 <div>
 <h4 className="font-bold mb-2">Informazioni Azienda</h4>
 <div className="space-y-2">
 <p><strong>Nome Azienda:</strong> {report.nome_azienda}</p>
 <p><strong>Nome Titolare:</strong> {report.nome_titolare}</p>
 <p><strong>Contatto Titolare:</strong> {report.contatto_titolare}</p>
 </div>
 </div>
 </div>

 <div className="mb-6">
 <h4 className="font-bold mb-2">Altre Informazioni</h4>
 <p className={`p-3 rounded ${theme==='dark' ? 'bg-gray-700' : 'bg-gray-100'}`}>
 {report.altre_informazioni || 'Nessuna informazione aggiuntiva'}
 </p>
 </div>

 <div className="mb-6">
 <h4 className="font-bold mb-2">Stato Segnalazione</h4>
 <div className={`inline-block px-3 py-1 rounded ${report.stato_segnalazione==='chiusura' ? 'bg-green-500' : report.stato_segnalazione==='secondo appuntamento fissato' ? 'bg-purple-500' : report.stato_segnalazione==='appuntamento fissato' ? 'bg-blue-500' : report.stato_segnalazione==='da lavorare' ? 'bg-yellow-500' : report.stato_segnalazione==='non interessato' ? 'bg-red-500' : 'bg-gray-500'} text-white`}>
 {report.stato_segnalazione}
 </div>
 </div>
 </div>
 </div>
 </div>
);

export default App;